import { resolve } from '../utils/objectUtils';

const defaultBankAccountTitles = {
  account_number: 'Номер банківського рахунку',
  balance_in_currency: 'Залишки у валюті',
  balance_in_uah: 'Залишки у гривні',
  bank: 'Банк',
  currency: 'Валюта',
  update_date: 'Дата оновлення інформації',
};

const defaultCompanyTitles = {
  annual_income: 'Прибуток з початку року',
  annual_limit: 'Ліміт прибутку на рік',
  company_name: 'Назва Компанії',
  director_fio: 'ПІБ Директора',
  edrpou_inn: 'ІПН/ЄДРПОУ',
  gross_expense: 'Валові витрати (грн)',
  gross_income: 'Валовий прибуток (грн)',
  profit: 'Індикативний прибуток (грн)',
  remaining_income: 'Залишок прибутку до кінця року',
  vat_credit: 'ПДВ: Податковий кредит',
  vat_liabilities: 'ПДВ: Податкові забовязання',
  vat_to_pay: 'ПДВ: До сплати',
  file_link_1: 'Cash Flow',
  file_link_2: 'P&L',
  file_link_3: 'Сховище'
};

export const bankAccountTitles = resolve(
  window,
  'ThemeSettings.data_titles.bank_account',
  defaultBankAccountTitles
);

export const companyTitles = resolve(
  window,
  'ThemeSettings.data_titles.company',
  defaultCompanyTitles
);
